import { render, staticRenderFns } from "./SeasonLink.vue?vue&type=template&id=05482b2c&"
import script from "./SeasonLink.vue?vue&type=script&lang=js&"
export * from "./SeasonLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports